import { Component } from '@angular/core';
import { Validators } from '@angular/forms';

import { BaseCrudComponent } from "../../base/base-crud.component";

@Component({
    selector: 'formacao-academica-crud',
    templateUrl: 'formacao-academica-crud.component.html'
})

export class CrudFormacaoAcademicaComponent extends BaseCrudComponent {
    controllerName = 'formacao-academica';
    init() {
        this.cadastro = this.formBuilder.group({
            nome: [null, [Validators.required, Validators.maxLength(100)]],
            id_situacao: [2],
            id: [null],
            data_inclusao: [new Date]
        });

    }

    finalizar(event: any) {
        this.doFinalAction(this.cadastro.value, this.controllerName);
    }
}


// WEBPACK FOOTER //
// ./src/app/formacao-academica/crud/formacao-academica-crud.component.ts